import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'

import logo from '../../images/logo.png'
import line from '../../images/line.png'

const SLogo = styled.img`
  height: 50px;
`

const SLine = styled.img`
  margin: 0 17px;
`

const SHeader = styled.header`
  background-color: white;
  padding: 0 64px;
  height: 80px;
  display: flex;
  align-items: center;
`

const SHeading = styled.div`
  font-size: 24px;
  line-height: 32px;
  color: ${(props) => props.theme.colors.accentText};
`

const Header: React.FC<HTMLAttributes<HTMLDivElement>> = ({className}) => {
  return (
    <SHeader className={className}>
      <a href="/">
        <SLogo src={logo} />
      </a>
      <SLine src={line} />
      <SHeading>ИПП Универсальный</SHeading>
    </SHeader>
  )
}

export default Header